@if (userContextFields) {
  <div class="row">
    <label>{{ 'ActorContextDialogMessage' | translate }}</label>
    <label>{{ 'ActorContextDialogCSKMessage' | translate }}</label><br>
    @for (field of userContextFields; track field) {
      <lm-application-menu-user-context-field
        [userContextField]="field"
        (contextValueChanged)="onContextValueChanged(field)"
        (modelDirty)="onModelDirty($event)"
      ></lm-application-menu-user-context-field>
    }
  </div>
} @else {
  <label>{{ 'ActorContextDialogEmpty' | translate }}</label>
}

